module.exports = __webpack_public_path__ + "img/gal-7.883fc9d8.jpg";